// YINN theme — minimal, progressive-enhancement helpers.
// No framework, no external dependency.

document.addEventListener('DOMContentLoaded', () => {
  // Reflect form submission on YINN submit buttons via the loading state class.
  document.querySelectorAll('form').forEach((form) => {
    form.addEventListener('submit', () => {
      const btn = form.querySelector('.yinn-btn.is-submit');
      if (btn && !btn.disabled) {
        btn.classList.add('is-loading');
      }
    });
  });

  const reduceMotion =
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    document.documentElement.classList.contains('yinn-reduce-motion');

  // Reduced motion: do not autoplay YINN videos.
  if (reduceMotion) {
    document.querySelectorAll('.yinn-video video[autoplay]').forEach((v) => {
      v.removeAttribute('autoplay');
      v.pause();
    });
  }

  // Click-to-play for YINN videos without native controls.
  document.querySelectorAll('[data-yinn-video-play]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const video = trigger.closest('.yinn-video')?.querySelector('video');
      if (video) {
        const p = video.play();
        if (p && p.catch) p.catch(() => {});
        trigger.remove();
      }
    });
  });
});
